import React, { useEffect, useState} from 'react';
import { connect } from 'react-redux';
import Utils from '../../utils';


const Bienvenido = (props) => {
  const today = new Date();
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (today.getHours() < 12) {
      setMessage('Buenos días');
    } else if (today.getHours() < 18) {
      setMessage('Buenas tardes');
    } else {
      setMessage('Buenas noches');
    }
  }, []);
  
  const capitalizeCustom = (data) => {
    if (data) {
      return data.toLowerCase().charAt(0).toUpperCase() + data.toLowerCase().slice(1)
    }
    return "";
  }

  const capitalizeFirstName = (firstName) => {
    if (firstName) {
      let nombre = "";
      const nameSplitted = firstName.toLowerCase().split(" ");
        nameSplitted.forEach(name => {
          nombre += " " + capitalize(name);
      });
      return nombre;
    }
    return "";
  }

  const capitalize = (value) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  return (
    <div>
      <p className="mb-0 mt-10"> ¡{message} {' '}
        { capitalizeFirstName(props.user.persona.nombre) } {' '}
        { capitalizeCustom(props.user.persona.primerApellido) } {' '}
        { capitalizeCustom(props.user.persona.segundoApellido) }! {' '}
      { Utils.Helpers.convertDate(today) } </p>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

export default connect(mapStateToProps)(Bienvenido);
